import { StateToken } from '@ngxs/store';
import { PosHardwareDetails } from 'src/app/store/app/app.state.model';

export type HardwareDeviceStateModel = Partial<PosHardwareDetails>;

export const HARDWARE_DEVICE_STATE_TOKEN =
  new StateToken<HardwareDeviceStateModel>('hardware_device');
